import { CloudOff, Download, RefreshCw, X } from 'lucide-react'
import { useState } from 'react'
import { useSyncStore } from '@/store'
import { Button } from '@/components/ui'

/** Full-width strip shown under the header when connectivity or the build changes. */
export function OfflineBanner() {
  const isOnline = useSyncStore((s) => s.isOnline)
  const queue = useSyncStore((s) => s.queue)
  const syncing = useSyncStore((s) => s.syncing)
  const flush = useSyncStore((s) => s.flush)
  const updateReady = useSyncStore((s) => s.updateReady)
  const applyUpdate = useSyncStore((s) => s.applyUpdate)
  const [dismissedUpdate, setDismissedUpdate] = useState(false)

  if (!isOnline) {
    return (
      <div
        role="status"
        className="flex items-center gap-2 border-b border-status-pending/30 bg-status-pending/10 px-4 py-2 text-xs text-status-pending no-print"
      >
        <CloudOff className="h-4 w-4 shrink-0" aria-hidden />
        <span>
          You are offline. Everything still works — {queue.length > 0 ? `${queue.length} change(s) are queued and ` : ''}
          your edits are stored on this device.
        </span>
      </div>
    )
  }

  if (queue.length > 0) {
    return (
      <div className="flex items-center gap-2 border-b border-border bg-muted px-4 py-2 text-xs text-muted-foreground no-print">
        <RefreshCw className="h-4 w-4 shrink-0" aria-hidden />
        <span className="flex-1">
          {queue.length} change{queue.length === 1 ? '' : 's'} waiting to sync.
        </span>
        <Button size="sm" variant="outline" onClick={() => void flush()} loading={syncing}>
          Sync now
        </Button>
      </div>
    )
  }

  if (updateReady && !dismissedUpdate) {
    return (
      <div className="flex items-center gap-2 border-b border-primary/30 bg-primary/10 px-4 py-2 text-xs text-primary no-print">
        <Download className="h-4 w-4 shrink-0" aria-hidden />
        <span className="flex-1">A new version of Services is ready.</span>
        <Button size="sm" onClick={() => applyUpdate?.()}>
          Reload
        </Button>
        <button
          type="button"
          className="rounded p-1 hover:bg-primary/10"
          onClick={() => setDismissedUpdate(true)}
          aria-label="Dismiss update notice"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    )
  }

  return null
}
